import { createContext, useContext, type ReactNode } from 'react';
import type { UserTenantResponseAPI } from '../types/user';

type TenantProviderProps = {
    tenant: UserTenantResponseAPI;
    children: ReactNode;
};

const TenantContext = createContext<UserTenantResponseAPI | null>(null);

const TenantProvider = ({ tenant, children }: TenantProviderProps) => {
    return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
};

const useTenant = (): UserTenantResponseAPI => {
    const context = useContext(TenantContext);
    if (context === null) {
        throw new Error('useTenant must be used within a TenantProvider');
    }
    return context;
};

export { TenantProvider, useTenant };
